(function (angular) {
    'use strict';

    angular.module('app')
        .controller('manageAdvertController', manageAdvertController);

    manageAdvertController.$inject = [
        'settings',
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'advertId',
        'AdvertsApi',
        'handleError',
        '$timeout',
        '$q',
        'UploadsApi',
        'confirmDialog',
        'alerts'
    ];

    function manageAdvertController(
        settings,
        $scope,
        $rootScope,
        $uibModalInstance,
        advertId,
        AdvertsApi,
        handleError,
        $timeout,
        $q,
        UploadsApi,
        confirmDialog,
        alerts
    ) {
        var vm = this;

        // properties
        vm.isLoading = false;
        vm.isLoadingMessage = 'Loading...';
        vm.advertId = advertId;
        vm.createNewAdvert = (advertId ? false : true);
        vm.thisUser = $rootScope.thisUser;
        vm.activeTab = 'about';
        vm.formErrors = {};
        vm.image = null;
        vm.advert = {
            description: '',
            position: null,
            startsAt: new Date(),
            endsAt: window.moment().add(1, 'weeks').toDate(),
        };
        vm.imageUploadOptions = {};
        vm.forceClose = false;

        // methods
        vm.close = function() { $uibModalInstance.close(vm.advert); };
        vm.handleImage = handleImage;
        vm.handleImageError = handleImageError;
        vm.saveAdvert = saveAdvert;
        vm.deleteAdvert = deleteAdvert;

        /**
         * Loads an advert to be edited
         * @return {void}
         */
        function getAdvert() {
            vm.isLoadingMessage = 'Loading Advert...';
            vm.isLoading = true;

            AdvertsApi.get({
                id: vm.advertId
            }, function (response) {

                // Add advert to scope and create date objects to be manipulated
                angular.extend(vm.advert, response.data, {
                    startsAt: new Date(response.data.starts_at),
                    endsAt: new Date(response.data.ends_at),
                });
                vm.originalImage = angular.copy(response.data.img);
                vm.isLoading = false;

            }, function (err) {
                vm.isLoading = false;
                handleError(err);
            });
        }

        /**
         * Handles the image chosen by the user
         * @param  {string} file - base64 image
         * @return {void}
         */
        function handleImage(file) {
            vm.advert.img = file;
        }

        /**
         * Shows file errors
         * @param  {object} imageError - provided as  {image: '[error msg]'}
         * @return {void}
         */
        function handleImageError(imageError) {
            vm.formErrors = angular.merge(vm.formErrors, imageError);
        }

        /**
         * Delete an advert
         */
        function deleteAdvert() {
            confirmDialog('Are you sure you want to delete this advert?')
                .result.then(function (confirm) {
                    if (confirm) {
                        AdvertsApi.delete({
                            id: vm.advertId
                        }, function() {
                            vm.isLoading = false;

                            // Close modal
                            $uibModalInstance.close({
                                deleted: true,
                                id: advertId
                            });
                        });
                    }
                });
        }

        /**
         * Attempts to create a new advert from the provided form data
         * @return {void}
         */
        function saveAdvert() {
            var funcName,
                params;

            vm.isLoading = true;
            if (vm.image) {
                vm.isLoadingMessage = 'Uploading image...';
            }

            if (vm.createNewAdvert) {
                funcName = 'save';
                params = {
                    id: vm.advertId
                };
            } else {
                funcName = 'update';
                params = {};
            }

            /**
             * Saves the advert to the API
             *
             * @returns {void}
             */
            function handleSave() {
                // set relevent loading message
                vm.isLoadingMessage = (vm.createNewAdvert ? 'Creating new advert...' : 'Saving advert...');

                // Convert dates to utc and format
                vm.advert.starts_at = window.moment(vm.advert.startsAt).startOf('day').format('Y-MM-DD HH:mm:ss');
                vm.advert.ends_at = window.moment(vm.advert.endsAt).endOf('day').format('Y-MM-DD HH:mm:ss');

                AdvertsApi[funcName](params, vm.advert, function (response) {
                    // Wait for UI prettiness
                    $timeout(function () {
                        vm.isLoading = false;

                        alerts.emit({
                            theme: 'success',
                            title: 'Saved',
                            messages: ['Advert'],
                        });

                        // Close modal
                        $uibModalInstance.close(response.data);
                    }, 400);
                }, function handleSaveAdvertError(err) {
                    vm.isLoading = false;
                    vm.formErrors = err.data;
                });
            }

            /**
             * Uploads the image to the API if it's been changed
             *
             * @returns {$q.promise}
             */
            function uploadImage() {
                var deferred = $q.defer();

                if (vm.originalImage === vm.advert.img) {
                    deferred.resolve();
                } else {
                    UploadsApi.uploadImage(vm.advert.img, 'site')
                        .then(
                            function (img) {
                                // hide progress bar
                                vm.isLoadingProgress = false;

                                // add uploaded image location to advert
                                if (img && img.path) {
                                    vm.advert.img = img.path;
                                }

                                deferred.resolve();
                            },
                            function handleUploadError(err) {
                                vm.isLoading = false;
                                vm.formErrors = err.data;
                            },
                            function handleUploadProgress(progress) {
                                vm.isLoadingProgress = progress;
                                if (progress >= 100) {
                                    vm.isLoadingProgress = 0;
                                    vm.isLoadingMessage = 'Saving Image...';
                                }
                            }
                        );
                }

                return deferred.promise;
            }

            uploadImage().then(handleSave);
        }

        // Catch the modal being closed for any reason
        $scope.$on('modal.closing', function (event, reason, closed) {
            if (!closed) {
                return event.preventDefault();
            }

            if (vm.forceClose) {
                return true;
            }

            if (Object.keys(vm.advert).length > 4) {
                event.preventDefault();

                // Todo: replace browser confirm with custom
                var exit = confirm('Are you sure?');
                if (exit) {
                    vm.forceClose = true;
                    $uibModalInstance.close(vm.advert);
                }
            }
        });

        /**
         * init
         */
        // Do we need to load an advert?
        if (!vm.createNewAdvert) {
            getAdvert();
        }
    }

}(angular));
